var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "uni-question-analysis" },
    [
      _c("div", { staticClass: "answer-box active" }, [
        _c("div", { staticClass: "p1" }, [
          _c("div", { staticStyle: { flex: "1" } }, [
            _vm.analysisDatas.question_style === 5
              ? _c("div", { staticClass: "scorePoints" }, [
                  _vm.analysisDatas.score_points
                    ? _c("div", { staticClass: "scorePointsList" }, [
                        _c("h3", [_vm._v("得分点详情")]),
                        _c(
                          "ul",
                          _vm._l(
                            JSON.parse(_vm.analysisDatas.score_points),
                            function (item, index) {
                              return _c(
                                "li",
                                { key: index },
                                [
                                  _c(
                                    "el-row",
                                    { attrs: { gutter: 20 } },
                                    [
                                      _c("el-col", { attrs: { span: 22 } }, [
                                        _c(
                                          "div",
                                          { staticClass: "scoreCenter" },
                                          [
                                            _c("p", [_c("em")]),
                                            _vm._v(
                                              " " +
                                                _vm._s(item.text) +
                                                " (" +
                                                _vm._s(item.fraction) +
                                                "分) "
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _c("el-col", { attrs: { span: 2 } }, [
                                        _c("p", { staticClass: "scoreDf" }, [
                                          _vm._v(
                                            " 得" +
                                              _vm._s(
                                                item.hasScored
                                                  ? item.hasScored
                                                  : 0
                                              ) +
                                              "分 "
                                          ),
                                        ]),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }
                          ),
                          0
                        ),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
            _c(
              "p",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.analysisDatas.question_style !== 5,
                    expression: "analysisDatas.question_style !== 5",
                  },
                ],
              },
              [
                _vm._v(" 参考答案： "),
                _c("span", { staticClass: "yes" }, [
                  _vm._v(_vm._s(_vm._f("getCorrect")(_vm.analysisDatas))),
                ]),
              ]
            ),
          ]),
          _c("p", [
            _c(
              "span",
              {
                staticClass: "opera",
                on: {
                  click: function ($event) {
                    _vm.correctVisible = !_vm.correctVisible
                  },
                },
              },
              [
                _c("i", { staticClass: "iconfont iconcuotiku mar5" }),
                _vm._v("纠错 "),
              ]
            ),
          ]),
        ]),
        _c("div", { staticClass: "p2" }, [
          _vm._v(" 参考解析： "),
          _c(
            "div",
            { staticClass: "resolve" },
            [
              _c("p", {
                domProps: { innerHTML: _vm._s(_vm.analysisDatas.analysis) },
              }),
              _vm.analysisDatas.analyze_thumb
                ? _c("el-image", {
                    staticClass: "mat20",
                    staticStyle: { width: "100px", color: "#fff" },
                    attrs: {
                      fit: "contain",
                      src: _vm.analysisDatas.analyze_thumb,
                      "preview-src-list": [_vm.analysisDatas.analyze_thumb],
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
      _vm.showNotes
        ? _c("div", { staticClass: "note-box" }, [
            _vm.analysisDatas.note && _vm.analysisDatas.note.length > 0
              ? _c(
                  "div",
                  { staticClass: "note-list" },
                  [
                    _c(
                      "el-timeline",
                      { attrs: { reverse: true } },
                      _vm._l(
                        _vm.analysisDatas.note,
                        function (activity, index) {
                          return _c(
                            "el-timeline-item",
                            {
                              key: index,
                              attrs: {
                                type: "primary",
                                icon: "el-icon-time",
                                size: "large",
                                placement: "top",
                                timestamp: activity.created_at,
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "space-between",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _vm._v(" " + _vm._s(activity.content) + " "),
                                  _c("div", { staticClass: "submit" }, [
                                    _c(
                                      "div",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.getDataDle(index)
                                          },
                                        },
                                      },
                                      [_vm._v("删除笔记")]
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          )
                        }
                      ),
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _c("ComponentCorrect", {
        attrs: { topicId: _vm.analysisDatas.id, visible: _vm.correctVisible },
        on: {
          "update:visible": function ($event) {
            _vm.correctVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }